var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "NCAcmi_check", class: { marTM: !_vm.isTop } }, [
      _c("input", {
        staticClass: "NCAcmi_checkbox",
        attrs: {
          id: "activity-check-" + _vm.unique,
          type: "checkbox",
          disabled: _vm.checkboxDisabled
        },
        domProps: { checked: _vm.checked },
        on: { change: _vm.checkVipExample }
      }),
      _vm._v(" "),
      _c(
        "label",
        {
          staticClass: "normal inline-label checklabel focus",
          attrs: { for: "activity-check-" + _vm.unique }
        },
        [
          _c(
            "span",
            {
              staticClass: "fntH6 bold",
              style: { color: _vm.checkboxDisabled ? "#bbbbbb" : "#ff6a07" }
            },
            [
              _vm._v(_vm._s(_vm.displayText) + " "),
              _vm.remainingNumber !== null
                ? _c("em", [
                    _vm._v("(잔여 " + _vm._s(_vm.remainingNumber) + ")")
                  ])
                : _vm._e()
            ]
          )
        ]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "padTSM" }, [
      _c(
        "select",
        {
          staticClass: "form-control NCAcmi_attendNum_box",
          attrs: {
            id: "activity-select-" + _vm.unique,
            disabled: !_vm.checked || _vm.checkboxDisabled
          },
          domProps: { value: _vm.se_data },
          on: {
            change: function($event) {
              return _vm.changeActivityValue({ se_data: $event.target.value })
            }
          }
        },
        [
          _c("option", { attrs: { value: "", hidden: "", disabled: "" } }, [
            _vm._v("참여인원 선택")
          ]),
          _vm._v(" "),
          _c("option", { attrs: { value: "0" } }, [_vm._v("불참")]),
          _vm._v(" "),
          _vm._l(_vm.numberOfAttendeesLimit, function(number) {
            return _c(
              "option",
              {
                key: _vm.example.se_code + "_" + number,
                domProps: { value: number }
              },
              [_vm._v(_vm._s(number) + "명")]
            )
          })
        ],
        2
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "NCAcmi_nameBox_wrap" }, [
      _c(
        "div",
        {
          staticClass: "NCAcmi_nameBox padBSM padTSM NCAcmi_nameBox_input",
          staticStyle: { "border-bottom": "none" }
        },
        [
          _c(
            "label",
            {
              staticClass: "fntP",
              attrs: { for: "activity-remarks-" + _vm.unique }
            },
            [_vm._v("실제 사용자"), _c("br"), _vm._v("(타인 양도가능)*")]
          ),
          _vm._v(" "),
          _c("input", {
            staticClass: "NCAcmi_checkInput01",
            attrs: {
              type: "text",
              id: "activity-remarks-" + _vm.unique,
              placeholder: "예) 홍길동(7480000)",
              disabled: _vm.remarksDisabled
            },
            domProps: { value: _vm.remarks },
            on: {
              input: function($event) {
                return _vm.changeActivityValue({ remarks: $event.target.value })
              }
            }
          })
        ]
      ),
      _vm._v(" "),
      _vm._m(0)
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "fntE txtL txtR light colorGray" }, [
      _vm._v(
        "\n      VIP 액티비티 모든 실참여자의 이름과 회원번호를 입력해주세요. "
      ),
      _c("br"),
      _vm._v("(6명 선택 시 6명 모두 다 입력 필요) 동반 가족이 이용 시, "),
      _c("br"),
      _vm._v("본인의 ABO번호와 동반가족의 이름을 입력해 주세요.\n    ")
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ce18a9d8", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ce18a9d8","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/survey2/components/SurveyActivityExampleVip.vue
// module id = null
// module chunks = 